// src/app/services/adminWallet.js
import http from "../api/http.js";

function extractDetail(err) {
  const data = err?.response?.data;
  if (!data) return err?.message || "Request failed";
  if (typeof data?.detail === "string") return data.detail;
  if (Array.isArray(data?.detail)) {
    return data.detail.map((d) => d?.msg || d?.message).filter(Boolean).join("; ");
  }
  return JSON.stringify(data);
}

export async function adminSearchUsers({ q = "", limit = 25, offset = 0 } = {}) {
  try {
    const res = await http.get("/admin/wallet/users/search", {
      params: { q, limit, offset },
    });
    return res.data;
  } catch (err) {
    err.message = extractDetail(err);
    throw err;
  }
}

export async function adminGetUserBalances({
  user_id,
  email,
  asset,
  network,
  limit = 50,
  offset = 0,
} = {}) {
  try {
    const res = await http.get("/admin/wallet/users/balances", {
      params: {
        user_id,
        email,
        asset,
        network,
        limit,
        offset,
      },
    });
    return res.data;
  } catch (err) {
    err.message = extractDetail(err);
    throw err;
  }
}

export async function adminAdjustBalance(payload) {
  try {
    const res = await http.post("/admin/wallet/balances/adjust", payload);
    return res.data;
  } catch (err) {
    err.message = extractDetail(err);
    throw err;
  }
}
